// extracted by mini-css-extract-plugin
module.exports = {"container":"MainContents_container_14JTZ","container_wide":"MainContents_container_wide_1GicJ"};